import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from '@/components/Product/ProductOptionPicker';

@Component
export class StockStatus extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;
    @Prop selectedVariant!: Shopify.Liquid.Variant;

    @Ref inStock!: HTMLElement;
    @Ref inStockText!: HTMLElement;
    @Ref outOfStock!: HTMLElement;

    @Ref noCountryRestriction!: HTMLElement;
    @Ref countryRestriction!: HTMLElement;
    @Ref collectionOnly!: HTMLElement;
    @Ref preOrderOnly!: HTMLElement;

    private activeItemClass: string = 'product-stock-status-item--active';
    private activeItemTextClass: string = 'product-stock-status-item__sub-text--active';

    init() {
        this.updateVisibility(this.selectedVariant);
        const productOptionPicker = document.getElementById('product-form-option-picker');
        if (productOptionPicker && productOptionPicker.tagName === 'PRODUCT-OPTION-PICKER') {
            const productOptionPickerComponent = productOptionPicker as ProductOptionPicker;
            // eslint-disable-next-line max-len
            this.$subscribe(productOptionPickerComponent.onSelectedVariantChange, (variant: Shopify.Liquid.Variant|null) => {
                if (variant) {
                    this.selectedVariant = variant;
                    this.updateVisibility(this.selectedVariant);
                }
            });
        }
    }

    updateVisibility(variant: Shopify.Liquid.Variant) {

        // Check variant is in stock
        if (variant.available) {

            // Show in stock item
            this.handleItemActiveClass(this.outOfStock, 'hide');
            this.handleItemActiveClass(this.inStock, 'show');
        } else {

            // Show out of stock item
            this.handleItemActiveClass(this.inStock, 'hide');
            this.handleItemActiveClass(this.outOfStock, 'show');

            // Do not continue
            return;
        }

        // Update in stock text
        this.inStockText.textContent = 'In Stock';

        // Check if product is for pre-order
        if (this.product.tags && this.product.tags.includes('preorder')) {

            // Only change stock status if variant quantity is <= 0
            if (variant.inventory_quantity && variant.inventory_quantity > 0) {
                return;
            }

            // Update in stock text
            this.inStockText.textContent = 'Pre-order';

            // Show pre-order only message
            this.removeAllItemTextActiveClasses();
            this.handleItemTextActiveClass(this.preOrderOnly, 'show');

            // Do not continue
            return;
        }

        // Check if product is pickup only
        if (this.product.tags && this.product.tags.includes('pickup-only')) {

            // Show pick only message
            this.removeAllItemTextActiveClasses();
            this.handleItemTextActiveClass(this.collectionOnly, 'show');

            // Do not continue
            return;
        }

        // Check if product has a shipping restriction
        if (this.product.tags && this.product.tags.includes('shipping-restriction')) {

            // Show shipping restriction message
            this.removeAllItemTextActiveClasses();
            this.handleItemTextActiveClass(this.countryRestriction, 'show');

            // Do not continue
            return;
        } else {

            // Show no shipping restriction message
            this.removeAllItemTextActiveClasses();
            this.handleItemTextActiveClass(this.noCountryRestriction, 'show');

            // Do not continue
            return;
        }
    }

    handleItemActiveClass(item: HTMLElement, action: string) {
        if (action === 'show') {
            item.classList.add(`${this.activeItemClass}`);
        } else {
            item.classList.remove(`${this.activeItemClass}`);
        }
    }

    handleItemTextActiveClass(item: HTMLElement, action: string) {
        if (action === 'show') {
            item.classList.add(`${this.activeItemTextClass}`);
        } else {
            item.classList.remove(`${this.activeItemTextClass}`);
        }
    }

    removeAllItemTextActiveClasses() {
        this.noCountryRestriction.classList.remove(`${this.activeItemTextClass}`);
        this.countryRestriction.classList.remove(`${this.activeItemTextClass}`);
        this.collectionOnly.classList.remove(`${this.activeItemTextClass}`);
        this.preOrderOnly.classList.remove(`${this.activeItemTextClass}`);
    }
}
